<!-- <?php
			require_once "$root/server/config.php";

			if(isset($_REQUEST['token']) && strlen($_REQUEST['token']) == 32){
				## Define Passed Variables
				$token = $_REQUEST['token'];

				## Make Sure There Is A Row With That Token
				$stmt = $DB_CONN->prepare("SELECT * FROM PasswordReset WHERE token = ?");
				$stmt->execute(array($token));
				if(count($stmt->fetchAll()) === 1){
		?> -->
		<div  style="max-width: 800px; margin: 2rem auto;">
			<h3 class="panel-title">Password Reset</h3>

			<section id="reset_password_success" [hidden]="!lastSuccess">
				<p>Your password has been reset successfully. You may now <a href="/login">login to your account.</a></p>
			</section>
			<div [hidden]="!linkExpired">
				<a href="/login">Your password reset link has expired. Please request a new one here.</a>
			</div>
      <div [hidden]="error === null" class="error"> 
        {{ error }} 
      </div>
			<div [hidden]="token != null">
				<a href="/">You appear to have reached this page in error. Please click this link to return home.</a>
			</div>

			<section id="reset_password_info" [hidden]="linkExpired">
				<p>Please provide your current password, and your new password below. Your password must meet the following requirements:</p>
				<ul>
					<li class="text-primary"><b>At least 8 characters</b></li>
					<li><b>At least 1 uppercase</b></li>
					<li><b>At least 1 lowercase</b></li>
					<li><b>At least 1 number or special character</b></li>
				</ul>
			</section>

			<form id="reset_password_form" >
				<input id="reset_password_token" name="token" type="hidden" [(ngModel)]="token" />
				<section class="form-group">
					<label class="form-required">Email Address</label>
					<input id="reset_password_email" name="reset_password_email" type="text" placeholder="john.doe@email.com" autocomplete="off" [(ngModel)]="email" required />
				</section>
				<section class="form-group">
					<label class="form-required">New Password</label>
					<input id="reset_password_npassword" name="reset_password_npassword" type="password" [(ngModel)]="password" required />
				</section>
				<section class="form-group">
					<label class="form-required">Confirm Password</label>
					<input id="reset_password_vpassword" name="reset_password_vpassword" type="password" [(ngModel)]="vpassword" required />
				</section>
				<br>
				<button type="submit" class="dcf-btn dcf-btn-primary" (click)="resetPassword()">Submit</button>
			</form>
		</div>